import { BatchInfo, CourseInfo } from '../redux/user/types'

const determineCourseFromBatch = (batchList: Array<BatchInfo>): Array<CourseInfo> => {
    const courseList = batchList.map((batch: BatchInfo) => {
        return batch?.course
    })

    return courseList
}

export default determineCourseFromBatch
